import * as HLF from "html-living-framework";
import * as VO from "../data/VO";

export const Assets = {
    boot: [
        new HLF.TextureAtlasAsset("boot-1"),
        new HLF.TextureAsset("SplashScreen-static", "images/static/SplashScreen-static.png"),
    ],
    common: [
        ...HLF.AssetFactory({"@1x": [1, 2], "@2x": [1, 2]}, (i) => new HLF.TextureAtlasAsset(`ui-${i}`)),
        new HLF.AudioAsset("buttonclick", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("correctanswer", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("wronganswer", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("badge-fanfare", HLF.AudioCategory.SFX),
        new HLF.SpineAsset("grover-profile", HLF.AssetType.SPINE_JSON, "grover-profile"),
    ],
    mainmenu: [
        new HLF.AudioAsset("main_menu_loop", HLF.AudioCategory.BGM),
        new HLF.AudioAsset(VO.MM_ACTIVITY01, HLF.AudioCategory.VO),
        new HLF.AudioAsset(VO.MM_ACTIVITY02, HLF.AudioCategory.VO),
        new HLF.AudioAsset(VO.MM_ACTIVITY03, HLF.AudioCategory.VO),
    ],
    trashcommon: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": 1}, (i) => new HLF.TextureAtlasAsset(`trashblast-${i}`)),
        new HLF.SpineAsset("oscar-trash-blaster", HLF.AssetType.SPINE_JSON, "oscar-trash-blaster"),
        new HLF.AudioAsset("correctanswer", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blaster-hose-creak", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash_blast_loop", HLF.AudioCategory.BGM),
        new HLF.AudioAsset("slimey", HLF.AudioCategory.SFX),
    ],
    trashcollect: [
        new HLF.AudioAsset("trash-blaster-suction", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blast-squirrel-shirp", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blast-squirrel-drop-nut", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blast-pigeon-peck", HLF.AudioCategory.SFX),
    ],
    trashreturn: [
        new HLF.AudioAsset("trash-blaster-blow", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blaster-blow-release-item", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("trash-blast-item-in-bin", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("wronganswer", HLF.AudioCategory.SFX),
    ],
    plantercommon: [
        ...HLF.AssetFactory({"@1x": [1, 2], "@2x": [1, 2]}, (i) => new HLF.TextureAtlasAsset(`plantercommon-${i}`)),
        new HLF.TextureAsset("planterparty-yellow-gradientmap", "images/static/planterparty-yellow-gradientmap.png"),
        new HLF.TextureAsset("planterparty-blue-gradientmap", "images/static/planterparty-blue-gradientmap.png"),
        new HLF.TextureAsset("planterparty-green-gradientmap", "images/static/planterparty-green-gradientmap.png"),
        new HLF.TextureAsset("planterparty-orange-gradientmap", "images/static/planterparty-orange-gradientmap.png"),
        new HLF.TextureAsset("planterparty-purple-gradientmap", "images/static/planterparty-purple-gradientmap.png"),
        new HLF.TextureAsset("planterparty-red-gradientmap", "images/static/planterparty-red-gradientmap.png"),
        new HLF.TextureAsset("planterparty-white-gradientmap", "images/static/planterparty-white-gradientmap.png"),
        new HLF.SpineAsset("abby-profile", HLF.AssetType.SPINE_JSON, "abby-profile"),
        new HLF.AudioAsset("planter_party_loop", HLF.AudioCategory.BGM),
        new HLF.AudioAsset("deadclick", HLF.AudioCategory.SFX),
    ],
    plantercustomize: [
        ...HLF.AssetFactory({"@1x": [1, 1], "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`plantercustomize-${i}`)),
    ],
    planterplanting: [
        ...HLF.AssetFactory({"@1x": [1, 1], "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`planterplanting-${i}`)),
        new HLF.AudioAsset("wand-002-gentle", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("planter-party-plant-grow", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("planter-party-bumble-bee", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("planter-party-shovel-dirt", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("planter-party-hose", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("planter-party-wood-chimes", HLF.AudioCategory.SFX),
    ],
    lightsoutcommon: [
        new HLF.SpineAsset("elmo-profile", HLF.AssetType.SPINE_JSON, "elmo-profile"),
        new HLF.AudioAsset("deadclick", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("correctanswer", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights_out_loop", HLF.AudioCategory.BGM),
    ],
    bathroom: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`lightsout-bathroom-${i}`)),
        new HLF.AudioAsset("lights-out-tap-drip", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-toothbrush", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-light-switch", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-electronics-button", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-teddy-squeak", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-rubber-duck", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-fish", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-soap-bubbles", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-roomfinish", HLF.AudioCategory.SFX),
    ],
    bedroom: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`lightsout-bedroom-${i}`)),
        new HLF.AudioAsset("lights-out-helicopter", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-lamp", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-light-switch", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-swinging-rocket", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-electronics-button", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-toy-car", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-toy-dinosaur", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-teddy-squeak", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-roomfinish", HLF.AudioCategory.SFX),
    ],
    kitchen: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`lightsout-kitchen-${i}`)),
        new HLF.AudioAsset("lights-out-fridge-door", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-light-switch", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-tap-drip", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-pots", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-cookie-jar", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-curtains", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-roomfinish", HLF.AudioCategory.SFX),
    ],
    livingroom: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`lightsout-livingroom-${i}`)),
        new HLF.AudioAsset("lights-out-electronics-button", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-lamp", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-robot", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-light-switch", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-guitar", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-globe", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-piano", HLF.AudioCategory.SFX),
        new HLF.AudioAsset("lights-out-roomfinish", HLF.AudioCategory.SFX),
    ],
    lightsoutIntro: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 1]}, (i) => new HLF.TextureAtlasAsset(`lightsout-intro-${i}`)),
    ],
};
